<template>
  <div
    @click="$emit('action')"
    class="button-container"
  >
    <div style="display: inline-block;">
      <span class="button-indicator">
        <slot></slot>
      </span>
    </div>
  </div>
</template>

<script>
import { colors } from "../../../constants";

export default {
  name: "ButtonTemplate",
  props: {
    backgroundColor: { type: String, default: colors.backgroundGrey },
    color: { type: String, default: colors.textBlueButton },
  },
  emits: ["action"],
};
</script>

<style scoped>
.button-indicator {
  cursor: pointer;
  color: var(--post-show-next-text);
}
.button-container {
  padding: 8px 12px 0;
  height: 24px;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  border-radius: 0 5px;
  margin-left: 5px;
  background: var(--post-buttom-background);
}
</style>
